<template>
    <b-row>
        <b-col>
            <!-- ---------------------------- FILTROS ---------------------------- -->
            <div class="painel-filtros">
                <div class="filtros-linha-principal">
                    <div class="busca-geral">
                        <i class="fas fa-search icone-busca"></i>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Pesquise por qualquer campo: nome, telefone, RA, responsável, e-mail..."
                            v-model="searchInput"
                        >
                        <i
                            v-show="searchInput"
                            class="fas fa-times limpar-busca"
                            title="Limpar pesquisa"
                            @click="searchInput = ''"
                        ></i>
                    </div>

                    <button
                        type="button"
                        class="btn-filtros-avancados"
                        :class="{ ativo: mostrarFiltros }"
                        @click="mostrarFiltros = !mostrarFiltros"
                    >
                        <i class="fas fa-sliders-h"></i>
                        Filtros
                        <span v-show="filtrosAtivos.length" class="contador-filtros">{{ filtrosAtivos.length }}</span>
                        <i class="fas" :class="mostrarFiltros ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </button>
                </div>

                <div v-show="mostrarFiltros" class="filtros-avancados">
                    <div class="grade-filtros">
                        <div class="campo-filtro">
                            <label>Fila - Transbordo</label>
                            <v-select placeholder="Selecione a fila" :options="user_queues_chat" v-model="queueSelect">
                                <template #no-options="{ }">Nenhum filtro encontrado.</template>
                            </v-select>
                        </div>

                        <div class="campo-filtro">
                            <label>Turma</label>
                            <v-select placeholder="Todas as turmas" :options="groups" v-model="groupSelect">
                                <template #no-options="{ }">Nenhum filtro encontrado.</template>
                            </v-select>
                        </div>

                        <div class="campo-filtro">
                            <label>Curso</label>
                            <v-select placeholder="Todos os cursos" :options="cursos" v-model="cursoSelect">
                                <template #no-options="{ }">Nenhum filtro encontrado.</template>
                            </v-select>
                        </div>

                        <div class="campo-filtro">
                            <label>Status da Matrícula</label>
                            <v-select placeholder="Todos os status" :options="status_matricula" v-model="statusSelect">
                                <template #no-options="{ }">Nenhum filtro encontrado.</template>
                            </v-select>
                        </div>

                        <div class="campo-filtro">
                            <label>Consultor</label>
                            <v-select placeholder="Todos os consultores" :options="consultores" v-model="consultorSelect">
                                <template #no-options="{ }">Nenhum filtro encontrado.</template>
                            </v-select>
                        </div>

                        <div class="campo-filtro">
                            <label>Nome do Responsável</label>
                            <input type="text" class="form-control" placeholder="Filtrar por responsável" v-model="responsavelInput">
                        </div>

                        <div class="campo-filtro">
                            <label>E-mail do Responsável</label>
                            <input type="text" class="form-control" placeholder="Filtrar por e-mail" v-model="emailInput">
                        </div>

                        <div class="campo-filtro">
                            <label>Matrícula (RA)</label>
                            <input type="text" class="form-control" placeholder="Filtrar por RA" v-model="raInput">
                        </div>

                        <div class="campo-filtro">
                            <label>Código da Família</label>
                            <input type="text" class="form-control" placeholder="Filtrar por código" v-model="familiaInput">
                        </div>

                        <div class="campo-filtro">
                            <label>Atualizado a partir de</label>
                            <input type="date" class="form-control" v-model="atualizadoDe">
                        </div>

                        <div class="campo-filtro">
                            <label>Atualizado até</label>
                            <input type="date" class="form-control" v-model="atualizadoAte">
                        </div>
                    </div>
                </div>

                <!-- Resumo do que esta filtrando, com remocao individual -->
                <div v-show="filtrosAtivos.length" class="chips-filtros">
                    <span v-for="filtro in filtrosAtivos" :key="filtro.chave" class="chip">
                        <b>{{ filtro.rotulo }}:</b> {{ filtro.valor }}
                        <i class="fas fa-times" title="Remover filtro" @click="limparFiltro(filtro.chave)"></i>
                    </span>
                    <button type="button" class="btn-limpar-tudo" @click="limparFiltros">
                        <i class="fas fa-eraser"></i> Limpar filtros
                    </button>
                </div>
            </div>

            <!-- ---------------------------- RESULTADO --------------------------- -->
            <b-row>
                <div class="table-wrapper">
                    <b-table
                        class="contacts-table"
                        striped
                        hover
                        fixed
                        show-empty
                        head-variant="dark"
                        :items="items"
                        :fields="fields"
                    >
                        <template v-slot:cell(action)="data">
                            <button v-show="!!data.item.check === true" class="btn btn-danger btn-table"
                                @click="delItem(data)"><i class="fas fa-times"></i> Remover</button>

                            <button v-show="!!data.item.check === false" class="btn btn-primary btn-table"
                                @click="addItem(data)"><i class="fas fa-plus"></i> Adicionar</button>
                        </template>

                        <template v-slot:cell(status_matricula)="data">
                            <span v-if="data.item.status_matricula" class="selo" :class="classeStatus(data.item.status_matricula)">
                                {{ data.item.status_matricula }}
                            </span>
                        </template>

                        <template #empty>
                            <div class="tabela-vazia">
                                <i class="fas fa-search"></i>
                                Nenhum contato encontrado com os filtros aplicados.
                            </div>
                        </template>
                    </b-table>
                </div>
            </b-row>

            <b-row id="count-row">
                <div id="total-count">
                    <span class="resultado-filtro">
                        Exibindo <b>{{ items.length }}</b> de <b>{{ at_wallets.length }}</b> contatos
                    </span>
                    <span class="separador-count">|</span>
                    TOTAL: <b>{{ totalChecked }}</b> contato<span v-show="totalChecked > 1">s</span> adicionado<span
                        v-show="totalChecked > 1">s</span>.
                </div>

                <div class="add-or-remove-all">
                    <button class="btn btn-primary" :disabled="!items.length" @click="addAll()">
                        Adicionar {{ temFiltro ? 'filtrados' : 'todos' }}
                    </button>
                    <button class="btn btn-danger" @click="delAll()">Remover todos</button>
                </div>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
const texto = (valor) => String(valor === null || valor === undefined ? '' : valor).toLowerCase();

export default {
    props: {
        wallets: {
            type: Array,
            default: []
        },
        groups: {
            type: Array,
            default: []
        },
        user_queues_chat: {
            type: Array,
            default: []
        },
        cursos: {
            type: Array,
            default: []
        },
        status_matricula: {
            type: Array,
            default: []
        },
        consultores: {
            type: Array,
            default: []
        }
    },
    data(){
        return {
            at_wallets: this.wallets,
            mostrarFiltros: false,
            groupSelect: 'Todos os grupos',
            cursoSelect: null,
            statusSelect: null,
            consultorSelect: null,
            queueSelect: null,
            responsavelInput: '',
            emailInput: '',
            raInput: '',
            familiaInput: '',
            atualizadoDe: '',
            atualizadoAte: '',
            searchInput: '',
            elementos: 1,
            fields: [
                {
                    key: 'action',
                    label: 'Ação',
                    class: 'text-center',
                    thStyle: {width: '120px'}
                },
                {
                    key: 'name',
                    label: 'Nome',
                    class: 'text-center',
                    sortable: true,
                    thStyle: {width: '200px'}
                },
                {
                    key: 'phone',
                    label: 'Telefone',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: 'msg_group',
                    label: 'Turma',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: 'company_name',
                    label: 'Curso',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: 'status_matricula',
                    label: 'Status',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: 'responsavel_nome',
                    label: 'Responsável',
                    class: 'text-center',
                    sortable: true
                },
            ]
        }
    },
    methods:{
        classeStatus(valor){
            const chave = texto(valor);
            if (chave.indexOf('ativ') === 0) return 'selo-ativo';
            if (chave.indexOf('tranc') === 0 || chave.indexOf('inativ') === 0) return 'selo-inativo';
            if (chave.indexOf('cancel') === 0) return 'selo-cancelado';
            return 'selo-neutro';
        },
        limparFiltro(chave){
            if (chave === 'groupSelect') return this.groupSelect = 'Todos os grupos';
            this[chave] = typeof this[chave] === 'string' ? '' : null;
        },
        limparFiltros(){
            this.searchInput = '';
            this.groupSelect = 'Todos os grupos';
            this.cursoSelect = null;
            this.statusSelect = null;
            this.consultorSelect = null;
            this.responsavelInput = '';
            this.emailInput = '';
            this.raInput = '';
            this.familiaInput = '';
            this.atualizadoDe = '';
            this.atualizadoAte = '';
        },
        addItem (data) {
            data.item.check = true
            const { name, phone } = data.item
            this.$emit('addClient', { name, phone });

        },
        delItem (data) {
            data.item.check = false
            const { name, phone } = data.item
            this.$emit('removeClient', { name, phone });

        },
        addAll () {
            // Adiciona apenas o que esta visivel no filtro atual
            this.items.forEach(item => {
                item.check = true
                const { name, phone } = item
                this.$emit('addClient', { name, phone });
            })
        },
        delAll () {
            // Limpa a marcacao de toda a base, e nao so do que esta filtrado,
            // porque o evento abaixo esvazia a campanha inteira
            this.at_wallets.forEach(item => {
                item.check = false
            });
            this.$emit('removeAllClients');
        },
    },
    computed: {
        // Um unico ponto de filtragem: todos os criterios se combinam
        items () {
            const busca = texto(this.searchInput).trim();
            const responsavel = texto(this.responsavelInput).trim();
            const email = texto(this.emailInput).trim();
            const ra = texto(this.raInput).trim();
            const familia = texto(this.familiaInput).trim();

            return this.at_wallets.filter(row => {
                if (busca) {
                    const alvo = [
                        row.name, row.phone, row.msg_group, row.company_name,
                        row.unique_key, row.status_matricula, row.responsavel_nome,
                        row.responsavel_email, row.codigo_familia, row.consultor
                    ].map(texto).join(' ');
                    if (!alvo.includes(busca)) return false;
                }

                if (this.groupSelect && this.groupSelect !== 'Todos os grupos') {
                    if (row.msg_group !== this.groupSelect) return false;
                }

                if (this.cursoSelect && row.company_name !== this.cursoSelect) return false;
                if (this.statusSelect && row.status_matricula !== this.statusSelect) return false;
                if (this.consultorSelect && row.consultor !== this.consultorSelect) return false;

                if (responsavel && !texto(row.responsavel_nome).includes(responsavel)) return false;
                if (email && !texto(row.responsavel_email).includes(email)) return false;
                if (ra && !texto(row.unique_key).includes(ra)) return false;
                if (familia && !texto(row.codigo_familia).includes(familia)) return false;

                if (this.atualizadoDe || this.atualizadoAte) {
                    // data_atualizacao chega como 'aaaa-mm-dd hh:mm:ss'
                    const dia = String(row.data_atualizacao || '').slice(0, 10);
                    if (!dia) return false;
                    if (this.atualizadoDe && dia < this.atualizadoDe) return false;
                    if (this.atualizadoAte && dia > this.atualizadoAte) return false;
                }

                return true;
            });
        },
        filtrosAtivos () {
            const lista = [];
            if (this.searchInput) lista.push({ chave: 'searchInput', rotulo: 'Pesquisa', valor: this.searchInput });
            if (this.groupSelect && this.groupSelect !== 'Todos os grupos') lista.push({ chave: 'groupSelect', rotulo: 'Turma', valor: this.groupSelect });
            if (this.cursoSelect) lista.push({ chave: 'cursoSelect', rotulo: 'Curso', valor: this.cursoSelect });
            if (this.statusSelect) lista.push({ chave: 'statusSelect', rotulo: 'Status', valor: this.statusSelect });
            if (this.consultorSelect) lista.push({ chave: 'consultorSelect', rotulo: 'Consultor', valor: this.consultorSelect });
            if (this.responsavelInput) lista.push({ chave: 'responsavelInput', rotulo: 'Responsável', valor: this.responsavelInput });
            if (this.emailInput) lista.push({ chave: 'emailInput', rotulo: 'E-mail', valor: this.emailInput });
            if (this.raInput) lista.push({ chave: 'raInput', rotulo: 'RA', valor: this.raInput });
            if (this.familiaInput) lista.push({ chave: 'familiaInput', rotulo: 'Cód. Família', valor: this.familiaInput });
            if (this.atualizadoDe) lista.push({ chave: 'atualizadoDe', rotulo: 'Atualizado de', valor: this.atualizadoDe });
            if (this.atualizadoAte) lista.push({ chave: 'atualizadoAte', rotulo: 'Atualizado até', valor: this.atualizadoAte });
            return lista;
        },
        temFiltro () {
            return this.filtrosAtivos.length > 0;
        },
        totalChecked () {
            let total = 0
            this.wallets.forEach(el => {
                if(!!el.check) total++
            });
            return total
        }

    },
    watch:{
        queueSelect(value) {
            this.$emit('addQueueIntoClients', value);
        }
    }

}
</script>

<style scoped>
    #city-search {
        width: 200px;
    }

    /* ------------------------------ Filtros ------------------------------ */
    .painel-filtros {
        background: #f7fafb;
        border: 1px solid #dde6e8;
        border-radius: 10px;
        padding: 12px;
        margin: 5px 0 10px 0;
    }

    .filtros-linha-principal {
        display: flex;
        gap: 12px;
        align-items: center;
    }

    .busca-geral {
        position: relative;
        flex: 1 1 auto;
        min-width: 0;
    }

    .busca-geral input {
        padding-left: 34px;
        padding-right: 30px;
    }

    .icone-busca {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #1C869A;
        pointer-events: none;
    }

    .limpar-busca {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        color: #90a4a9;
        cursor: pointer;
    }

    .limpar-busca:hover { color: #aa1a1a; }

    .btn-filtros-avancados {
        display: flex;
        align-items: center;
        gap: 8px;
        white-space: nowrap;
        background: #fff;
        color: #1C869A;
        border: 2px solid #1C869A;
        border-radius: 10px !important;
        font-weight: bold;
        padding: 6px 14px;
    }

    .btn-filtros-avancados:hover,
    .btn-filtros-avancados.ativo {
        background: #1C869A;
        color: #fff;
    }

    .contador-filtros {
        background: #f38630;
        color: #fff;
        border-radius: 10px;
        padding: 0 7px;
        font-size: 12px;
    }

    .filtros-avancados {
        margin-top: 12px;
        border-top: 1px dashed #cfdde0;
        padding-top: 12px;
    }

    .grade-filtros {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
        gap: 10px 14px;
    }

    .campo-filtro label {
        display: block;
        margin-bottom: 2px;
        font-size: 12px;
        font-weight: bold;
        color: #40575c;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }

    /* -------------------------------- Chips ------------------------------- */
    .chips-filtros {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
        margin-top: 12px;
    }

    .chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: #e4f1f4;
        color: #14606f;
        border: 1px solid #bcdde4;
        border-radius: 10px;
        padding: 2px 10px;
        font-size: 12px;
        max-width: 260px;
    }

    .chip b { font-weight: 700; }

    .chip i {
        cursor: pointer;
        color: #14606f99;
    }

    .chip i:hover { color: #aa1a1a; }

    .btn-limpar-tudo {
        background: none;
        border: none;
        color: #aa1a1a;
        font-size: 12px;
        font-weight: bold;
        text-decoration: underline;
        padding: 0 4px;
    }

    /* ------------------------------- Tabela ------------------------------- */
    #count-row{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 10px;
        flex-wrap: wrap;
        gap: 8px;
    }
    #total-count{
        align-self: center;
    }
    .resultado-filtro { color: #40575c; }
    .separador-count { margin: 0 6px; color: #b9c8cb; }

    .contacts-table>thead>tr{
        background: #1C869A;
        color: white;
    }
    td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 1px;
    }
    .b-table-sticky-header{
        max-height: 35vh;
    }
    .add-or-remove-all button{
        border-radius: 10px !important;
    }
    .btn-table{
        border-radius: 10px !important;
        font-size: 10px;
        margin: 0px;
    }
    .table-wrapper {
        max-height: 400px;
        overflow-y: auto;
        width: 100%;
    }

    .tabela-vazia {
        text-align: center;
        color: #7b8f94;
        padding: 18px;
    }

    .tabela-vazia i { margin-right: 6px; }

    .selo {
        display: inline-block;
        padding: 0.15em 0.6em;
        border-radius: 10px;
        font-size: 0.8em;
        font-weight: 600;
        white-space: nowrap;
    }

    .selo-ativo     { background-color: #e2f3e5; color: #1e7b32; }
    .selo-inativo   { background-color: #fdf1dc; color: #96620a; }
    .selo-cancelado { background-color: #fbe3e3; color: #a32020; }
    .selo-neutro    { background-color: #e8edee; color: #40575c; }
</style>
